<template>
  <div class="w-full p-8 max-w-md mx-auto stack-lg">
    <div class="w-full flex justify-center">
      <avatar :avatar="makeUrl() || avatar" />
    </div>
    <input-file label="Avatar" @update-value="updateForm('file', $event)" required />
    <div>
      <wd-button :sending="sending" @input="uploadAvatar">Hochladen</wd-button>
    </div>
  </div>
</template>

<script>
const Avatar = require("@/modules/avatars/components/Avatar.vue").default;
const InputFile = require("@/modules/input/components/InputFile.vue").default;

import FormMixin from "@/mixins/FormMixin";

export default {
  name: "AvatarSelect",
  mixins: [FormMixin],
  data() {
    return {
      updateAvatarFormOptions: {},
      fileFormData: new FormData()
    };
  },
  props: {
    avatar: {
      default: null,
      type: String
    }
  },
  components: {
    Avatar,
    InputFile
  },
  methods: {
    emitSelect(Avatar) {
      this.$emit("select", Avatar);
    },
    uploadAvatar() {
      for (let [key, value] of Object.entries(this.formData)) {
        this.fileFormData.append(key, value);
      }
      this.submit(this.updateAvatarFormOptions);
    },
    makeUrl() {
      return this.formData.file
        ? URL.createObjectURL(this.formData.file)
        : false;
    }
  },
  computed: {},
  async created() {
    this.$store.dispatch("header/update", {
      clear: true,
      elements: [
        {
          location: "left",
          value: "Avatar Upload",
          css: "tracking-wide"
        },
        {
          location: "right",
          type: "icon",
          value: "Close",
          action: () => {
            this.$emit("close");
          }
        }
      ]
    });
    this.updateAvatarFormOptions = {
      custom: true,
      async: true,
      type: "useravatar",
      call: "update",
      data: this.fileFormData,
      action: async response => {
        this.popup({
          type: "success",
          title: "Profilbild aktualisiert",
          autoHide: true
        });
        this.goTo("/profile");
        this.$store.dispatch("useravatar/updateAvatar", response);
      }
    };
  }
};
</script>